export default __webpack_public_path__ + "static/media/avatar.010f65da.jpg";